export const HIDE_TABBAR_PARAM = 'hideTabbar';

export const PROMOTION_DEFAULT_GOAL_ID = '12';
